// Recipients editor shared by "Email now" and the schedule dialog.
import { useState } from "react";
import { Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

export function RecipientsField({ value, onChange, sendToSelf, onSendToSelf, myEmail, testid = "recipients" }) {
  const [draft, setDraft] = useState("");
  const add = () => {
    const parts = draft.split(/[,;\s]+/).map((s) => s.trim().toLowerCase()).filter((s) => s.includes("@"));
    if (!parts.length) return;
    onChange(Array.from(new Set([...(value || []), ...parts])));
    setDraft("");
  };
  return (
    <div className="space-y-2">
      <Label className="text-xs font-semibold uppercase tracking-wide text-slate-500">Recipients</Label>
      <div className="flex gap-2">
        <Input value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="name@company.com"
               onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
               data-testid={`${testid}-input`} className="h-9" />
        <Button type="button" variant="outline" size="sm" className="h-9" onClick={add} data-testid={`${testid}-add`}>
          <Plus className="h-4 w-4" /> Add
        </Button>
      </div>
      <div className="flex flex-wrap gap-1.5" data-testid={`${testid}-chips`}>
        {(value || []).map((e) => (
          <span key={e} className="inline-flex items-center gap-1 rounded-full bg-slate-100 py-0.5 pl-2.5 pr-1 text-xs text-slate-700"
                data-testid={`${testid}-chip-${e}`}>
            {e}
            <button type="button" onClick={() => onChange(value.filter((x) => x !== e))}
                    className="rounded-full p-0.5 text-slate-400 hover:bg-slate-200 hover:text-slate-700" aria-label={`Remove ${e}`}>
              <X className="h-3 w-3" />
            </button>
          </span>
        ))}
        {!(value || []).length && <span className="text-xs text-slate-400">No addresses yet.</span>}
      </div>
      {onSendToSelf && (
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <Switch checked={!!sendToSelf} onCheckedChange={onSendToSelf} data-testid={`${testid}-self`} />
          Also send to me{myEmail ? ` (${myEmail})` : ""}
        </label>
      )}
    </div>
  );
}
